module.exports = __webpack_public_path__ + "static/colombia-371d7c3a806e1fd696681828d969ea5c.png";